import FrontLightsMode from "../cleaning-configurations/front-lights-mode";
import { CleaningConfiguration } from "./global-cleaning-configuration";

export const INHERIT = "Inherit";
type INHERIT_TYPE = typeof INHERIT;

export interface MapRulesConfiguration {
  beeper: boolean | null;
  frontLightsMode: FrontLightsMode | null;
  warningLight: boolean | null;
  drivingSpeed: number | null;
  minObstacleHeightM: number | null;
}

export interface MapRulesConfigurationApi {
    beeper: boolean | INHERIT_TYPE;
    frontLightsMode: FrontLightsMode | INHERIT_TYPE;
    warningLight: boolean | INHERIT_TYPE;
    drivingSpeed: number | INHERIT_TYPE;
    minObstacleHeightM: number | INHERIT_TYPE;
}

export const isMapRulesConfiguration = (data: Partial<MapRulesConfiguration> | Partial<CleaningConfiguration>): data is Partial<MapRulesConfiguration> => {
  return "beeper" in data || "frontLightsMode" in data || "warningLight" in data || "drivingSpeed" in data || "minObstacleHeightM" in data;
};

export const mapMapRulesConfigurationApiToMapRulesConfiguration = (apiData: MapRulesConfigurationApi) =>
({
    beeper: apiData.beeper === INHERIT ? null : apiData.beeper,
    frontLightsMode: apiData.frontLightsMode === INHERIT ? null : apiData.frontLightsMode,
    warningLight: apiData.warningLight === INHERIT ? null : apiData.warningLight,
    drivingSpeed: apiData.drivingSpeed === INHERIT ? null : apiData.drivingSpeed,
    minObstacleHeightM: apiData.minObstacleHeightM === INHERIT ? null : apiData.minObstacleHeightM,
} as MapRulesConfiguration);

export const mapMapRulesConfigurationToApi = (mapRulesConfiguration: MapRulesConfiguration) =>
({
    beeper: mapRulesConfiguration.beeper ?? INHERIT,
    frontLightsMode: mapRulesConfiguration.frontLightsMode ?? INHERIT,
    warningLight: mapRulesConfiguration.warningLight ?? INHERIT,
    drivingSpeed: mapRulesConfiguration.drivingSpeed ?? INHERIT,
    minObstacleHeightM: mapRulesConfiguration.minObstacleHeightM ?? INHERIT,
} as MapRulesConfigurationApi);

export const mapPartialMapRulesConfigurationToApi = (mapRulesConfiguration: Partial<MapRulesConfiguration>) =>
({
    beeper:
        mapRulesConfiguration.beeper !== undefined
            ? mapRulesConfiguration.beeper === null ? INHERIT : mapRulesConfiguration.beeper
            : undefined,
    frontLightsMode:
        mapRulesConfiguration.frontLightsMode !== undefined
            ? mapRulesConfiguration.frontLightsMode === null ? INHERIT : mapRulesConfiguration.frontLightsMode
            : undefined,
    warningLight:
        mapRulesConfiguration.warningLight !== undefined
            ? mapRulesConfiguration.warningLight === null ? INHERIT : mapRulesConfiguration.warningLight
            : undefined,
    drivingSpeed:
        mapRulesConfiguration.drivingSpeed !== undefined
            ? mapRulesConfiguration.drivingSpeed === null ? INHERIT : mapRulesConfiguration.drivingSpeed
            : undefined,
    minObstacleHeightM:
        mapRulesConfiguration.minObstacleHeightM !== undefined
            ? mapRulesConfiguration.minObstacleHeightM === null ? INHERIT : mapRulesConfiguration.minObstacleHeightM
            : undefined,
} as MapRulesConfigurationApi);